export class ListAccessGrantsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "grants",
            "baseName": "grants",
            "type": "Array<DataCatalogAccessGrant>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAccessGrantsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
